import React, { useEffect, useRef, useState } from "react";
import TRLowFiBuyTurretPanel from "../../TerminalRimCaseStudyImgs/terminalrim-2.png";
import TRPlayerShipConceptArt from "../../TerminalRimCaseStudyImgs/terminalrim-8.png";
import TRLowFiGameUi1 from "../../TerminalRimCaseStudyImgs/terminalrim-9.png";
import TRLowFiGameUi2 from "../../TerminalRimCaseStudyImgs/terminalrim-10.png";
import TRLowFiGameUi3 from "../../TerminalRimCaseStudyImgs/terminalrim-11.png";
import TRHeaderText from "../../TerminalRimCaseStudyImgs/terminalrim-13.png";
import TRLowFiGameOverModal from "../../TerminalRimCaseStudyImgs/terminalrim-14.png";
import TREnemyShipsConceptArt from "../../TerminalRimCaseStudyImgs/terminalrim-15.png";
import TRTurretConceptArt from "../../TerminalRimCaseStudyImgs/terminalrim-17.png";
import TREnemyShipsModels from "../../TerminalRimCaseStudyImgs/terminalrim-18.png";
import TRBoidsIdeation from "../../TerminalRimCaseStudyImgs/terminalrim-19.png";
import TREnemySpawnsScreenshot from "../../TerminalRimCaseStudyImgs/terminalrim-22.png";

import TRGameOverScreenshot from "../../TerminalRimCaseStudyImgs/terminalrim-27.png";
import TRMainMenuScreenshot from "../../TerminalRimCaseStudyImgs/terminalrim-28.png";
import TRSurveyScreenshot from "../../TerminalRimCaseStudyImgs/terminalrim-29.png";

import BodyContentHeader from "../../common/BodyContentHeader";
import "./CaseStudy.scss";

const TerminalRimCaseStudy = () => {
  const TopRef = useRef(null);
  const IntroductionRef = useRef(null);
  const StartingTheDesignRef = useRef(null);
  const ImplementationRef = useRef(null);
  const UsabilityStudyRef = useRef(null);
  const RefiningTheDesignRef = useRef(null);
  const GoingForwardRef = useRef(null);
  const CaseStudyNavRef = useRef(null);
  const IntroImgRef = useRef(null);

  const [caseStudyNavBarFixed, setCaseStudyNavBarFixed] = useState("relative");

  const scrollToSection = (Ref) => {
    Ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const stickNavbar = () => {
    if (window !== undefined) {
      if (
        IntroImgRef.current.getBoundingClientRect().top < 60 &&
        caseStudyNavBarFixed !== "fixed"
      ) {
        setCaseStudyNavBarFixed("fixed");
      } else if (
        IntroImgRef.current.getBoundingClientRect().top > 60 &&
        caseStudyNavBarFixed !== "relative"
      ) {
        setCaseStudyNavBarFixed("relative");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar, true);
    return () => {
      window.removeEventListener("scroll", stickNavbar, true);
    };
    // eslint-disable-next-line
  }, [caseStudyNavBarFixed]);

  return (
    <div ref={TopRef} className="body_content_container_child">
      <BodyContentHeader
        headerTitle="TerminalRim"
        headerSubtitle="A 3D space shooter and tower defense adventure."
        imgSrc="../notebook.svg"
        imgAlt="notebook image"
      />

      <div
        ref={CaseStudyNavRef}
        id="case_study_nav_bar"
        className={`${caseStudyNavBarFixed}`}
      >
        <button onClick={() => scrollToSection(IntroductionRef)}>Intro</button>
        <button onClick={() => scrollToSection(StartingTheDesignRef)}>
          Starting the Design
        </button>
        <button onClick={() => scrollToSection(ImplementationRef)}>
          Design Implementation
        </button>
        <button onClick={() => scrollToSection(UsabilityStudyRef)}>
          Usability Study
        </button>
        <button onClick={() => scrollToSection(RefiningTheDesignRef)}>
          Refining the design
        </button>
        <button onClick={() => scrollToSection(GoingForwardRef)}>
          Going Forward
        </button>
        <button onClick={() => scrollToSection(TopRef)}>Back to top</button>
      </div>

      <div ref={IntroImgRef} id="case_study_container">
        <div id="case_study_intro_img_container">
          <img
            id="case_study_intro_img"
            src={TRHeaderText}
            alt="terminal rim promotional poster"
          />
        </div>

        <div id="case_study_intro_img_container">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/jC34NeqIGwg?si=6_eYvUj7DKbEW4zn"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h1 ref={IntroductionRef}>Introduction</h1>

        <div className="case_study_section_2_col">
          <div className="case_study_col_subsection">
            <h2>The Product:</h2>
            <h3>
              TerminalRim is a first person shooter and tower defense game, in
              which the player defends their space station against an alien
              invasion using turrets and a player controlled ship.
            </h3>
          </div>
          <div className="case_study_col_subsection">
            <h2>Duration:</h2>
            <h3>April 2025 - August 2025</h3>
          </div>

          <div className="case_study_col_subsection">
            <h2>The Challenge:</h2>
            <h3>
              As part of the Technical University of Munich Games Lab program,
              we were tasked with creating a fully completed game based on a
              semester theme. For this semester, the theme was &quot;Road to
              Nowhere&quot;.
            </h3>
          </div>

          <div className="case_study_col_subsection">
            <h2>The Goal:</h2>
            <h3>
              Design, develop, test, and deploy a fully completed game within
              the semester, meeting milestones set forth for development
              goalposts (alpha stage, beta stage, etc.) along the way.
            </h3>
          </div>
          <div className="case_study_col_subsection">
            <h2>Audience:</h2>
            <h3>Gaming enthusiasts, ranging from teens to older adults.</h3>
          </div>
          <div className="case_study_col_subsection">
            <h2>My Role:</h2>
            <h3>UX Designer, Conceptor, UI Developer</h3>
            <h3>
              Responsible for ideation, concept art, user research, wireframes,
              mockups, prototyping, and UI implementation.
            </h3>
          </div>
        </div>

        <h1 style={{ textAlign: "center", fontSize: "35px" }}>
          The major challenges:
        </h1>

        <div id="pain_points_container">
          <div className="pain_point">
            <div className="pain_point_number">1</div>
            <h3 className="pain_point_header">
              <b>Time</b>
            </h3>
            <div className="pain_point_desc">
              We only have a single semester to fully develop and release the
              game as a team.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">2</div>
            <h3 className="pain_point_header">
              <b>Scope</b>
            </h3>
            <div className="pain_point_desc">
              Given the broad nature of the theme, as well as the timing
              constraints, keeping our project within a doable scope is vital.
              We could not risk impulsively tacking on features and
              nice-to-haves, as we could inevitably run out of time.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">3</div>
            <h3 className="pain_point_header">
              <b>Technical Achievement</b>
            </h3>
            <div className="pain_point_desc">
              One of the requirements of our grading was a technical
              achievement; ours was multithreading to allow massive spawns of
              enemy ships. This also posed a UX challenge, as the user needs to
              focus on multiple things at any given time.
            </div>
          </div>
        </div>

        <h1 ref={StartingTheDesignRef}>Starting the Design</h1>

        <div className="case_study_large_img_container">
          <img
            className="case_study_large_img"
            src={TRBoidsIdeation}
            alt="terminal rim boids ideation"
          />
        </div>

        <div className="case_study_section_1_col">
          <h3>
            First, we sat down as a team and discussed the themes and genres we
            were willing to develop. Then, we formed a consensus around our
            commonly shared interests, namely strategy games and space
            adventures. We were torn between tower defense and shooter genres,
            so we decided to try a hybrid as a design challenge.
          </h3>

          <div className="case_study_row_subsection">
            <img
              src={TRPlayerShipConceptArt}
              alt="terminal rim player ship concept art"
            />
            <div className="case_study_col_subsection">
              <h2>Concept Art</h2>
              <h3>
                I sketched some initial designs for objects we were certain we
                wanted in the game for our basic deliverables.
              </h3>
              <h3>
                We knew we wanted a controllable player ship, turrets and
                buildings for tower defense elements, and enemy ships of various
                shapes and abilities.
              </h3>
            </div>
          </div>

          <div className="case_study_large_img_container">
            <img
              className="case_study_large_img"
              src={TREnemyShipsConceptArt}
              alt="terminal rim enemy ships concept art"
            />
          </div>

          <div className="case_study_large_img_container">
            <img
              className="case_study_large_img"
              src={TRTurretConceptArt}
              alt="terminal rim enemy ships concept art"
            />
          </div>

          <div className="case_study_row_subsection">
            <div className="case_study_col_subsection">
              <h2>Low Fidelity Wireframes</h2>
              <h3>
                There are two main modes of gameplay: The ship mode, in which
                the player flies around in the spaceship to shoot enemies
                directly, and buy mode, in which the user buys turrets and
                buildings to gather resources and shoot enemies on their behalf.
                Because of this, it was necessary to make the user journey as
                seamless and intuitive as possible, since some users might find
                swapping between these modes and the use of features within the
                modes to be otherwise too complicated.
              </h3>
            </div>
            <img
              src={TRLowFiGameUi1}
              alt="terminal rim low fidelity prototype screenshots"
            />
          </div>

          <div className="case_study_row_subsection">
            <img
              src={TRLowFiGameUi2}
              alt="terminal rim low fidelity prototype screenshots"
            />
            <div className="case_study_col_subsection">
              <h3>
                Quite a few wireframes were created as a result. Here, you can
                see an example draft for the buy mode.
              </h3>
            </div>
          </div>

          <div className="case_study_row_subsection">
            <div className="case_study_col_subsection">
              <h3>
                Because outer space and the sheer number of enemies and
                buildings/turrets that would be on screen, we opted for designs
                that maximized the amount of space the user would see, to
                prevent UI occlusion of the game space.
              </h3>
            </div>
            <img
              src={TRLowFiGameUi3}
              alt="terminal rim low fidelity prototype screenshots"
            />
          </div>

          <div className="case_study_row_subsection">
            <img
              src={TRLowFiGameOverModal}
              alt="terminal rim low fidelity prototype screenshots"
            />
            <div className="case_study_col_subsection">
              <h2>Refinements</h2>
              <h3>
                Once we were happy with our low-fidelity wireframes, we began to
                stylize the UI elements and settle into an aesthetic that fit
                the theme of our game.
              </h3>
            </div>
          </div>
        </div>

        <h1 ref={ImplementationRef}>Design Implementation</h1>

        <div className="case_study_large_img_container">
          <img
            className="case_study_large_img"
            src={TRLowFiBuyTurretPanel}
            alt="terminal rim turret models"
          />
        </div>

        <div className="case_study_section_1_col">
          <div className="case_study_row_subsection">
            <div className="case_study_col_subsection">
              <h2>From Concept Art to Model</h2>
              <h3>
                We iterated upon the concept art and the wireframes, and once we
                were satisfied, we passed the concept art onto our team member,
                Jonas Hack, responsible for 3D modeling the game objects.
              </h3>
            </div>
            <img
              src={TREnemyShipsModels}
              alt="terminal rim low fidelity prototype screenshots"
            />
          </div>

          <div className="case_study_row_subsection">
            <img
              src={TRGameOverScreenshot}
              alt="terminal rim low fidelity prototype screenshots"
            />
            <div className="case_study_col_subsection">
              <h3>
                Here, you can see the first iteration of our Game Over screen,
                using elements of the mockups I designed. I implemented these
                with Unity canvas UI elements.
              </h3>
            </div>
          </div>

          <div className="case_study_row_subsection">
            <div className="case_study_col_subsection">
              <h3>
                We ensured a consistent look by establishing UI element styles
                that fit our game theme, namely the translucent, futuristic
                hologram modals and dialog font.
              </h3>
            </div>
            <img
              src={TRMainMenuScreenshot}
              alt="terminal rim main menu screenshot"
            />
          </div>
        </div>

        <h1 ref={UsabilityStudyRef}>Usability Study</h1>

        <div className="case_study_section_2_col">
          <div className="case_study_col_subsection">
            <h2>Research Goal:</h2>
            <h3>
              Assess the usability, progression, difficulty, and entertainment
              of the game. Then, combine the results of user feedback into
              actionable insights to make improvements to the game.
            </h3>
          </div>
          <div className="case_study_col_subsection">
            <h2>Duration:</h2>
            <h3>June 23, 2025</h3>
          </div>

          <div className="case_study_col_subsection">
            <h2>Methodology:</h2>
            <h3>
              Remote, unmoderated usability study. Users followed prompts while
              recording their screen and voice as they tested the site.
            </h3>
          </div>

          <div className="case_study_col_subsection">
            <h2>Participants:</h2>
            <h3>
              <ol>
                <li>Adults who are interested in gaming</li>
                <li>
                  Two men, two women, and one non-binary individual, all between
                  the ages of 18 and 75.
                </li>
                <li>
                  At least one user must have a vision impairment (glasses,
                  color blindness, etc).
                </li>
              </ol>
            </h3>
          </div>
        </div>

        <div className="case_study_section_1_col">
          <div className="case_study_row_subsection">
            <img src={TRSurveyScreenshot} alt="terminal rim survey" />
            <div className="case_study_col_subsection">
              <h2>Participant Feedback</h2>
              <h3>
                Participants were sent a google form with step-by-step
                instructions on exploring and playing the game. They also
                recorded their screens and voices as they participated in the
                survey, allowing me to document their click paths, feelings, and
                significant quotes on a google sheet.
              </h3>
            </div>
          </div>
        </div>

        <h1 style={{ textAlign: "center", fontSize: "35px" }}>Findings:</h1>

        <div id="pain_points_container">
          <div className="pain_point">
            <div className="pain_point_number">1</div>
            <h3 className="pain_point_header">
              <b>The turret system was unintuitive.</b>
            </h3>
            <div className="pain_point_desc">
              4 out of 6 participants had severe issues with the turret system.
              Users were struggling to intuitively figure out or find
              information on the use of turrets within the game. They were
              unsure of how to acquire resources to buy turrets, placing turrets
              themselves, and whether or not the turrets did anything.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">2</div>
            <h3 className="pain_point_header">
              <b>Users struggled to control the ship.</b>
            </h3>
            <div className="pain_point_desc">
              4 out of 6 participants had severe issues with controlling the
              ship. Specifically, they cited issues with mouse sensitivity. This
              means that the mouse sensitivity will need to be significantly
              increased, or a settings page is needed for the user to adjust it
              themselves.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">3</div>
            <h3 className="pain_point_header">
              <b>Users were dissatisfied with the difficulty scaling.</b>
            </h3>
            <div className="pain_point_desc">
              3 out of 6 participants cited dissatisfaction with the game’s
              difficulty scaling. Specifically, the game is “too easy”. This
              means that users are not satisfied with the rate at which the
              difficulty increases with each wave of enemies.
            </div>
          </div>
        </div>

        <h1 ref={RefiningTheDesignRef}>Refining the design</h1>

        <div className="case_study_section_1_col">
          <h3>
            After the usability study was completed, we used the feedback to
            make adjustments to the UI and ship controls.
          </h3>

          <div className="case_study_row_subsection">
            {/*<img
              src={AAEditsOne}
              alt="auction art wireframe edits of back button"
            />*/}
            <div className="case_study_col_subsection">
              <h2>Tutorial</h2>
              <h3>
                When the user starts the game, they will be taken through an
                introductory phase to walk them through ship controls and buy
                mode before massive waves of enemies appear.
              </h3>
            </div>
            <div className="case_study_col_subsection">
              <h2>Settings modal</h2>
              <h3>
                The user can now control mouse sensitivity directly via the
                Settings modal, which is accessible from both the main menu and
                pause menu.
              </h3>
            </div>
          </div>

          <div className="case_study_row_subsection">
            <div className="case_study_col_subsection">
              <h2>Improved Difficulty Scaling</h2>
              <h3>
                The rate by which enemy spawns increase overtime was
                significantly hastened, so the users would need to continuously
                improve their tower defense setup to handle the new threats.
              </h3>
            </div>
            <img
              src={TREnemySpawnsScreenshot}
              alt="terminal rim screenshot of many enemies"
            />
          </div>
        </div>

        <h1 style={{ textAlign: "center", fontSize: "35px" }}>
          Accessibility Considerations:
        </h1>

        <div id="pain_points_container">
          <div className="pain_point">
            <div className="pain_point_number">1</div>
            <h3 className="pain_point_header">
              <b>Motion Sickness</b>
            </h3>
            <div className="pain_point_desc">
              We were aware that our game is especially prone to motion
              sickness, since both the ship and enemy spawns can move in all 6
              degrees of freedom in outer space. Because of this, we were
              cautious of strobe effects and panning the camera too quickly.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">2</div>
            <h3 className="pain_point_header">
              <b>Leveraging Color Theory for Friend Vs. Foe</b>
            </h3>
            <div className="pain_point_desc">
              There could easily be thousands of enemies on the screen in this
              game at once, as well as hundreds of user turrets. To help users
              keep track of friendly vs. unfriendly game objects and
              projectiles, enemy ships and attacks were color coded with warm
              colors. The user&apos;s ship, projectiles, and buildings/turrets
              are primarily blue and white to maximize visibility.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">3</div>
            <h3 className="pain_point_header">
              <b>UI Scaling</b>
            </h3>
            <div className="pain_point_desc">
              Not everyone will have the same screen resolution. The designs
              were created with scalability in mind to suit a variety of screen
              sizes and dimensions.
            </div>
          </div>
        </div>

        <h1 ref={GoingForwardRef}>Going Forward</h1>

        <div className="case_study_section_2_col">
          <div className="case_study_col_subsection">
            <h2>Impact:</h2>
            <h3>
              The TerminalRim game was a massive success and was featured during
              the 2025 TUM Demo Day conference for the public to play.
            </h3>
          </div>
          <div className="case_study_col_subsection">
            <h2>What I learned:</h2>
            <h3>
              This was my first time developing a game with a team, and I gained
              tremendous experience in real game development. Not only did I use
              Unity and the C# programming language for the first time, but I
              learned a lot about team collaboration and publishing.
            </h3>
          </div>
        </div>

        <h1 style={{ textAlign: "center", fontSize: "35px" }}>
          My Recommended Next Steps:
        </h1>

        <div id="pain_points_container">
          <div className="pain_point">
            <div className="pain_point_number">1</div>
            <h3 className="pain_point_header">
              <b>Add more ship capabilities.</b>
            </h3>
            <div className="pain_point_desc">
              Special abilities for the ship were planned early on but were
              ultimately cut due to time constraints. However, I think adding
              additional ship abilities/powers would incentivize the user to
              more frequently swap between buy mode and ship mode. After a
              while, users would spend much longer times simply buying turrets
              to deal with enemies.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">2</div>
            <h3 className="pain_point_header">
              <b>Add more building variants.</b>
            </h3>
            <div className="pain_point_desc">
              We only have a few building types to place on asteroids, namely
              for resource mining the three resource types. However, we have far
              more asteroids than necessary for our current number of buildings.
              We can leverage this to add more building types.
            </div>
          </div>

          <div className="pain_point">
            <div className="pain_point_number">3</div>
            <h3 className="pain_point_header">
              <b>Add boss fights.</b>
            </h3>
            <div className="pain_point_desc">
              Our difficulty scaling at the moment is purely the number and
              frequency of enemy waves. It would be neat to have boss fights as
              interludes, to add new and dynamic strategy changes to the
              gameplay loop.
            </div>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <img
            style={{ width: "300px", maxWidth: "100%", margin: "auto" }}
            src="../teila_head.png"
            alt="teila's head"
          />
        </div>
        <h1 style={{ textAlign: "center", fontSize: "35px", margin: "0px" }}>
          Thank you!
        </h1>
      </div>
    </div>
  );
};

export default TerminalRimCaseStudy;
